<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Order ID</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.OrderID"
                    autocomplete="off"
                    type="text"
                    id="OrderID"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Customer ID</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.CustomerID"
                    autocomplete="off"
                    type="text"
                    id="CustomerID"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Quantity</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RecipientQuantity"
                    autocomplete="off"
                    type="text"
                    id="Quantity"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">CAP/IOV</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.CAP"
                    autocomplete="off"
                    type="text"
                    id="CAP"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Client</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RAName"
                    autocomplete="off"
                    type="text"
                    id="ship_name"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Company</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RACompany"
                    autocomplete="off"
                    type="text"
                    id="ship_name"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Address</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RAAddress1"
                    autocomplete="off"
                    type="text"
                    id="ship_address_1"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Ste./Bldg</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RAAddress2"
                    autocomplete="off"
                    type="text"
                    id="ship_address_2"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">City</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RACity"
                    autocomplete="off"
                    type="text"
                    id="ship_city"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">State/Province</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RAState"
                    autocomplete="off"
                    type="text"
                    id="ship_state"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Postal Code</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RAZip"
                    autocomplete="off"
                    type="text"
                    id="ship_postal_code"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Country</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="mcap.client_direct_order_edit.RACountry"
                    autocomplete="off"
                    type="text"
                    id="ship_country"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <div class="form-group form-actions" style="float:left;">
                <b-button style="width:185px;" size="md" variant="primary" @click="back">
                  <i class="fa fa-arrow-left"></i>
                  Close Order Detail
                </b-button>
              </div>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                  <a
                    :href="artworkLink"
                    target="_blank"
                    class="btn btn-success"
                    style="width:185px;"
                    role="button"
                  >
                    Download IOV Artwork
                    <!-- <i class="fa fa-search appendIcon"></i> -->
                  </a>
                  <a
                    v-if="hasCoverLetter"
                    :href="mcapArtworkLink"
                    target="_blank"
                    class="btn btn-success ml-3"
                    style="width:200px;"
                    role="button"
                  >
                    Download Cover Letter
                    <!-- <i class="fa fa-search appendIcon"></i> -->
                  </a>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>

          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    type="text"
                    placeholder="Search"
                    @keyup="filterList"
                    v-model="searchString"
                  />

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">&nbsp;</b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-table
                @row-clicked="myRowClickHandler"
                :items="filteredOrders"
                :fields="fields"
                hover
                small
                fixed
                caption
                selectable
                select-mode="single"
                responsive="sm"
                selectedVariant="success"
                :current-page="currentPage"
                :per-page="perPage"
              ></b-table>

              <nav v-show="isNavVisible">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="totalRows"
                  v-model="currentPage"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons
                />
              </nav>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ClientDirectOrder",
  data() {
    return {
      selected: [], // Must be an array reference!
      fields: [
        {
          key: "BuffiniRecipientID",
          label: "ID",
          sortable: true
        },
        {
          key: "RecName",
          label: "Name",
          sortable: true
        },
        {
          key: "RecAddress1",
          label: "Address",
          sortable: true
        },
        {
          key: "RecAddress2",
          label: "Ste./Bldg",
          sortable: true
        },
        {
          key: "RecCity",
          label: "City",
          sortable: true
        },
        {
          key: "RecState",
          label: "ST",
          sortable: true
        },
        {
          key: "RecZip",
          label: "Zip",
          sortable: true
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 50,
      filteredOrders: [],
      filterStatus: "all",
      searchString: ""
    };
  },
  mounted() {
    this.filterList();
    // this.$store
    //   .dispatch("mcap/loadRecipients")
    //   .then(
    //     (this.filteredOrders = this.$store.state.mcap.client_direct_orders)
    //   );
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    loadArtwork() {},
    filterList: function() {
      this.filteredOrders = this.$store.state.mcap.recipients;
      this.filteredOrders = this.filteredOrders.filter(
        ord =>
          ord.RecName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.RecAddress1.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.RecAddress2.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.RecCity.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1
      );
    },

    myRowClickHandler(record, index) {
      //   this.$store.dispatch("mcap/loadOrderEdit", record.OrderID).then(() => {
      //     this.$router.push({ name: "ClientDirectOrder" });
      //});
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  },
  computed: {
    ...mapState(["mcap", "n_user"]),
    ...mapGetters({
      totalRows: "mcap/RecipientCount"
      // ,
      // getterMonth(capBase): "mcap/getMonthByBase(params)"
    }),
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    artworkLink() {
      return (
        "http://proofs.icap-maker.com/GetHistoricalpdf.aspx?OrderID=" +
        this.$store.state.mcap.client_direct_order_edit.OrderID
      );
    },
    mcapArtworkLink() {
      var _cb = this.$store.state.mcap.client_direct_order_edit.CAP.substring(
        0,
        6
      );
      return (
        "http://dashboard.icap-maker.com/CoverLetters/" +
        _cb +
        "/" +
        this.$store.state.mcap.client_direct_order_edit.CustomerID +
        "-Letter.pdf"
      );
    },
    hasCoverLetter() {
      //alert(this.$store.getters.getMonthByBase("201909").HasCoverLetters);

      //alert(this.getterMonth("201910").HasCoverLetters);
      var _cb = this.$store.state.mcap.client_direct_order_edit.CAP.substring(
        0,
        6
      );
      return this.$store.state.mcap.months.find(month => month.CapBase === _cb)
        .HasCoverLetters;
    }
    //this.$store.state.mcap.client_direct_order_edit.CAP
    //).HasCoverLetters;

    // hasTrackingInfo() {
    //   return this.$store.state.mcap.client_direct_order_editTrackingNumber;
    // },
    // trackingLink() {
    //   return (
    //     "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=" +
    //     this.$store.state.mcap.client_direct_order_editTrackingNumber
    //   );
    // }
  },
  components: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
